import styled from '@emotion/styled';
import {LogoWhite as LogoWhiteUi} from 'ui';
import {colors} from 'ui/config';

export const Container = styled('div')({
  backgroundColor: '#F6F6F6',
});

export const HeaderRow = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  backgroundColor: colors.darkBrown,
  paddingTop: 28,
  paddingLeft: 20,
  paddingRight: 20,
  '> div': {
    position: 'relative',
    top: 'auto',
    right: 'auto',
  },
});

export const LogoWhite = styled(LogoWhiteUi)({
  img: {
    width: 27,
    height: 13,
    marginBottom: 8,
  },
});
